import { useEffect } from "react";

/**
 * Sets document.title and updates (or creates) the meta[name="description"] tag on mount.
 * Restores the previous values on unmount.
 */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = tag?.getAttribute("content") ?? null;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (tag) {
        if (prevDesc === null) tag.remove();
        else tag.setAttribute("content", prevDesc);
      }
    };
  }, [title, description]);
}

export default usePageMeta;
